import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Select, FormControl, MenuItem, Button } from '@material-ui/core';
import { useLanguageSettings } from 'views/Settings';

const useStyles = makeStyles((theme) => ({
    formControl: {
        '& .MuiInputBase-formControl': {
            height: '40px'
        }
    },
    multiPagePanel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-around',
        marginTop: '16px'
    }
}));

const PageLayout = props => {
    const { pageIterators, pageLayout, setPageLayout } = props;
    const classes = useStyles();
    const { templateLanguageContent, getTemplateLanguageContent } = useLanguageSettings();
    const [componentContent, setComponentContent] = React.useState(null);

    React.useEffect(() => {
    if (templateLanguageContent) {
        setComponentContent(getTemplateLanguageContent("components", "multipageLayout"));
    }
    }, [templateLanguageContent]);
    
    const handleChange = (value) => {
        setPageLayout(value);
    };
    return (
        <div className={classes.multiPagePanel}>
            <div>
                <FormControl variant="outlined" className={classes.formControl}>
                    <Select
                        native
                        id="select-outlined"
                        value={pageLayout}
                        onChange={(e) => handleChange(e.target.value)}
                    >
                        {pageIterators.length === 0 ? (
                            <MenuItem key="none" value="none" disabled>
                                {componentContent?.noOptions || `No options`}
                            </MenuItem>
                        ) : (
                            <>
                                <option value="" selected disabled hidden>{componentContent?.selectLayoutLabel || `Select Multipage Layout`}</option>
                                {pageIterators?.map(frame => {
                                    if(frame.dataFrames.length > 0) {
                                        return (<optgroup label={frame.productName}>
                                            {frame.dataFrames.map(f => {
                                                return <option value={f.key} data-productname={frame.productName}>{f.name}</option>
                                            })}
                                        </optgroup>)
                                    }
                                })}
                            </>
                        )}
                    </Select>
                </FormControl>
            </div>
            <div>
                <Button variant="contained" onClick={() => handleChange('')} color="secondary">
                    {componentContent?.resetButtonLabel || `Reset`}
                </Button>
            </div>
        </div>
    );
};

export default PageLayout;